import React, { useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import ColdStorageKg from "../../../images/material_orange.svg";

import KgEntered from "../../../images/material_kg.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import Button from "../../../components/shared/buttons/button";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import MaterialEnteredModal from "./MaterialEnteredModal";
import {
  useGetBrokerageMaterialQuery,
  useGetBrokerageSummaryQuery,
  useGetMaterialEnteredSummaryQuery,
} from "./materialApi";
import BrokerageSortinModal from "../sorting/BrokerageSortinModal";
import OverViewModal from "./OverViewModal";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
import usePermissions from "../../../hooks/usePermissions";

//  ######### Material Entered ##############

const MaterialEntered = () => {
  const { _t } = useTranslator();  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [page, setPage] = useState(1);
  const [addMaterial, setAddMaterial] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [overview, setOverView] = useState(null);
  const [sortedMaterial, setSortedMaterial] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState({});

  const { checkPermission } = usePermissions();
  
  const accessToEdit  = checkPermission("brokerage.edit_material_entered" , "update");
  
  const handleAddMaterial = () => {
    setAddMaterial(true);
    setModalMode("add");
    setSelectedMaterial(null);
    setShowModal(true);
  };
  const handleEditCounting = (data) => {
    setAddMaterial(true);
    if(data.status == "counting" || data.status == "mixing" || accessToEdit){
      setModalMode("edit");
    }else{
      setModalMode("view");
    }
    setSelectedMaterial(data);
    setShowModal(true);
  };

  const handleView = (unloading) => {
    setOverView(true);
    setSelectedMaterial(unloading);
    setShowModal(true);
  };

  const {
    data: brokerageMaterial,
    isLoading,
    isFetching,
    isError,
    error,
    refetch : refetchRecord 
    } = useGetBrokerageMaterialQuery({
      page,
      status: ["sorting","counting" ,"packaging","packed",'mixing'],
      ...filter
    });

  const { data: summaryData } = useGetMaterialEnteredSummaryQuery({
    date,
  });
  // 

  const listItems = [
    {
      label: _t("total_dried_mango_kg", "Total Dried Mango KG"),
      value: summaryData?.data?.total_dried_mango_kg,
      icon: KgEntered,
    },
    {
      label: _t("total_cheeks_kg", "Total Cheeks KG"),
      value: summaryData?.data?.total_cheeks_kg,
      icon: ColdStorageKg,
    },
    {
      label: _t("total_strips_kg", "Total Strips KG"),
      value: summaryData?.data?.total_strips_kg,
      icon: ColdStorageKg,
    },
    {
      label: _t("total_pieces_kg", "Total Pieces KG"),
      value: summaryData?.data?.total_pieces_kg,
      icon: ColdStorageKg,
    }
  ];

  const handleEdit = (unloading) => {
    setSortedMaterial(true);
    setModalMode("edit");
    setSelectedMaterial(unloading);
    setShowModal(true);
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const columns = [
    {
      label: _t("date", "Date"),
      accessor: "entered_date_time",
      cell: ({ value }) => {
        return convertToUserTimezone(value);
      },
    },
    { label: _t("supplier_name", "Supplier Name"), accessor: "supplier_name" },
    { label: _t("batch_code", "Batch Code"), accessor: "batch_code" },
    {
      label: _t("fruit_type_variety", "Fruit Type Variety"),
      accessor: "fruit_type_variety",
      cell: ({ value }) =>{
        // console.log(value)
        return value
          ? _t(
              value,
              value.charAt(0).toUpperCase() + value.slice(1)
            )
          : "";
      }
      },
    { label: _t("total_entered_kg", "Total Entered KG"), accessor: "total_entered_kg" },
    // { label: _t("pasting_kg", "Pasting KG"), accessor: "pasting_kg" ,cell: ({value}) => value ? value : "N/A" },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => {

        let displayText = value;
      
        if (value === "counting") {
          displayText = _t("unloading", "Unloading");
        } else if (value === "packaging") {
          displayText = _t("still_sorting_and_packing", "Still Sorting/Packing");
        } else if (value === "packed") {
          displayText = _t("packed", "Packed");
        }else{
           displayText = _t(value,value);
        }

        return (
          <span
            className={
              value === "packed"
                ? "cmn_badge"
                : "cmn_badge inactive"
            }
          >
            {displayText}
          </span>
        );
      },
    },
    {
      label: _t("overview", "Overview"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          <Button
            size="small"
            label={
              row.status !== "counting" && row.status !== "mixing" && !accessToEdit
                ? _t("view", "View")
                : _t("edit", "Edit")
            }
            className={(row.status !== "counting" &&  row.status !== "mixing"  && !accessToEdit )? "borderRedBtn" : ""}
            onClick={
              row.status === "counting"
                ? () => handleEditCounting(row)
                : () => handleEditCounting(row)
            }
            // disabled={row.status === "packaging"}
          />
        </>
      ),
    },
  ];
  return (
    <div>
      {addMaterial && (
        <MaterialEnteredModal
          show={showModal}
          setShow={setAddMaterial}
          mode={modalMode}
          record={selectedMaterial}
        />
      )}
      {/* {sortedMaterial && (
        <BrokerageSortinModal
          show={showModal}
          setShow={setSortedMaterial}
          mode={modalMode}
          unloading={selectedMaterial}
        />
      )} */}
      {overview && (
        <OverViewModal
          show={showModal}
          setShow={setOverView}
          mode={modalMode}
          record={selectedMaterial}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("material_entered_overview", "Material Entered Overview")}
          </h6>

          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT )}
              showDay={list?.showDay}
            />
          ))}
        </ul>
      </div>      
      <Datatable
        title={_t("material_entered_log", "Material Entered Log")}
        columns={columns}
        tableData={brokerageMaterial?.data}
        buttons={[
          {
            label: _t("add_brokerage_material", "Add Brokerage Material"),
            onClick: handleAddMaterial,
            icon: PlusSvg,
          },
        ]}
        pagination
        page={page}
        onPageChange={handlePageChange}
        showFilter={setFilter}
        showFilterButton={false}
        filterModule="brokerage-material-entered-fltr"
        isLoading={isLoading || isFetching}
      />      
    </div>
  );
};

export default MaterialEntered;
